module.exports = __webpack_public_path__ + "img/background-3.ca8ee1f4.jpg";